/*
LF-LCP3: Dynamic Image Priority Management
FUNCTION: Manages fetchpriority attribute on product images to optimize LCP (Largest Contentful Paint)
USAGE: Automatically loaded in theme.liquid
DESCRIPTION:
  - On initial page load, the selected_or_first_available_variant's featured image has fetchpriority="high" (set by Liquid)
  - When variant changes, this script dynamically updates fetchpriority to ensure only the currently visible image has high priority
  - Listens for 'variantImageChange' event and updates fetchpriority accordingly
*/

// Wrap everything in an IIFE
(function(){

  // Debug flag - set to true to see console logs
  const IMAGE_PRIORITY_DEBUG = false;

  // Log helper
  function log(message, data) {
    if (IMAGE_PRIORITY_DEBUG) {
      console.log('[LF-LCP3] ' + message, data || '');
    }
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    log('Image priority manager initialized');
    initImagePriorityManager();
  });

  /**
   * Initialize the image priority manager
   * Listens for variant change events and updates fetchpriority
   */
  function initImagePriorityManager() {
    // Listen for variant image change events
    // The theme.js triggers this event with: dispatchEvent(new CustomEvent('variantImageChange', {detail: {variant: variant}}))
    // We listen on the document for events bubbling from product containers
    document.addEventListener('variantImageChange', function(evt) {
      log('Variant image change detected', evt.detail);

      if (evt.detail && evt.detail.variant) {
        updateImagePriority(evt.detail.variant);
      }
    });
    log('Event listener attached (vanilla JS)');
  }

  /**
   * Update fetchpriority attribute on product images
   * @param {Object} variant - The selected variant object
   */
  function updateImagePriority(variant) {
    if (!variant || !variant.featured_media) {
      log('No featured media for variant');
      return;
    }

    const mediaId = variant.featured_media.id;
    log('Updating priority for media ID:', mediaId);

    // Find all product images
    const allProductImages = document.querySelectorAll('.product-main-slide .image-element');

    // Remove fetchpriority from all images
    allProductImages.forEach(function(img) {
      if (img.hasAttribute('fetchpriority')) {
        img.removeAttribute('fetchpriority');
        log('Removed fetchpriority from image');
      }
    });

    // Find the new variant's image and add fetchpriority="high"
    const newSlide = document.querySelector('.product-main-slide[data-id="' + mediaId + '"]');
    if (newSlide) {
      const newImage = newSlide.querySelector('.image-element');
      if (newImage) {
        newImage.setAttribute('fetchpriority', 'high');
        log('Added fetchpriority="high" to new variant image');
      }
    } else {
      log('Could not find slide for media ID:', mediaId);
    }
  }

})();
